import * as React from "react";
import { SVGProps, memo } from "react";

const SvgTruck = (props: SVGProps<SVGSVGElement>) => (
  <svg width={39} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask id="Truck_svg__a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.002 16.485A.586.586 0 0 1 24 16.44V7.56c0-.308.242-.56.538-.56h8.13c.295 0 .538.252.538.56L34.91 16h3.511c.318 0 .578.237.578.527v7.946c0 .29-.26.527-.578.527H24.578c-.318 0-.578-.237-.578-.527v-7.946c0-.014 0-.028.002-.042Z"
      />
    </mask>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.002 16.485A.586.586 0 0 1 24 16.44V7.56c0-.308.242-.56.538-.56h8.13c.295 0 .538.252.538.56L34.91 16h3.511c.318 0 .578.237.578.527v7.946c0 .29-.26.527-.578.527H24.578c-.318 0-.578-.237-.578-.527v-7.946c0-.014 0-.028.002-.042Z"
      fill="#71C0F4"
    />

    <path
      d="m24.002 16.485 1.594.14.011-.133-.01-.133-1.595.126Zm9.204-8.924h-1.6v.16l.031.157 1.569-.317ZM34.91 16l-1.568.317.26 1.283h1.308V16Zm-9.314.36c.002.026.003.053.003.08h-3.2c0 .057.002.115.007.172l3.19-.253Zm.003.08V12h-3.2v4.44h3.2Zm0-4.44V7.56h-3.2V12h3.2Zm0-4.44c0 .514-.413 1.04-1.062 1.04V5.4c-1.24 0-2.138 1.03-2.138 2.16h3.2ZM24.538 8.6h8.13V5.4h-8.13v3.2Zm8.13 0a1.049 1.049 0 0 1-1.062-1.04h3.2c0-1.13-.898-2.16-2.139-2.16v3.2Zm-1.03-.722 1.705 8.439 3.136-.634-1.705-8.44-3.137.635ZM34.91 17.6h3.511v-3.2h-3.51v3.2Zm3.511 0a1.046 1.046 0 0 1-1.022-1.073h3.2c0-1.308-1.117-2.127-2.178-2.127v3.2ZM37.4 16.527v7.946h3.2v-7.946h-3.2Zm0 7.946c0-.728.597-1.073 1.022-1.073v3.2c1.061 0 2.178-.82 2.178-2.127h-3.2Zm1.022-1.073H24.578v3.2h13.844v-3.2Zm-13.844 0c.425 0 1.022.345 1.022 1.073h-3.2c0 1.308 1.117 2.127 2.178 2.127v-3.2Zm1.022 1.073v-7.946h-3.2v7.946h3.2Zm0-7.946c0 .033-.001.065-.004.097l-3.188-.278c-.005.06-.008.12-.008.181h3.2Z"
      fill="#2B323B"
      mask="url(#Truck_svg__a)"
    />

    <path d="M.8 24.2V.8h24.397v23.4H.8Z" fill="#D0EAFB" stroke="#2B323B" strokeWidth={1.6} />

    <path
      d="M6.35 29.873c2.356 0 4.267-1.92 4.267-4.29s-1.91-4.29-4.267-4.29-4.267 1.92-4.267 4.29 1.91 4.29 4.267 4.29ZM32.64 29.873c2.357 0 4.267-1.92 4.267-4.29s-1.91-4.29-4.267-4.29-4.267 1.92-4.267 4.29 1.91 4.29 4.267 4.29Z"
      fill="#2B323B"
    />

    <path
      d="M32.64 27.327c.958 0 1.735-.78 1.735-1.744 0-.962-.777-1.743-1.734-1.743a1.74 1.74 0 0 0-1.735 1.744c0 .963.777 1.743 1.735 1.743Z"
      fill="#D0EAFB"
    />

    <path
      d="m33.032 10.9 1.204 5.9h-5.364l-.063-5.9h4.223Z"
      fill="#fff"
      stroke="#2B323B"
      strokeWidth={1.6}
    />
  </svg>
);

const Memo = memo(SvgTruck);

export default Memo;
